<template>
    <div class="card-item affair" style="overflow: auto;">
        <div class="flex-box al-c mb10 titleClass">
            <div>我的事务 <span style="color: #98adc3;font-size: 12px">/Business</span></div>
            <div>
                <i class="el-icon-refresh" @click="getTableData"></i>
                <span style="cursor: pointer;" @click="goAff">事务查询</span>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div>
            <el-radio-group v-model="radio3" size="small" @change="getTableData">
                <el-radio-button label="待办"></el-radio-button>
                <el-radio-button label="已办"></el-radio-button>
                <el-radio-button label="我的发起"></el-radio-button>
            </el-radio-group>
        </div>
        <div class="cont" style="height: 130px;overflow: auto">
            <el-table class="w100 mt20 table"  :show-header="false" :data="tableData" @row-click="rowClick" v-loading="loading">
                <el-table-column align="left" prop="processName" label="名称" v-if="this.radio3 == '待办'">
                    <template slot-scope="scope">
                        <span style="cursor:pointer">{{scope.row.processName.length > 10 ? scope.row.processName.substring(0, 10) + '...' : scope.row.processName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="taskName" label="名称" v-if="this.radio3 != '待办'">
                    <template slot-scope="scope">
                        <span style="cursor:pointer">{{scope.row.taskName.length > 10 ? scope.row.taskName.substring(0, 10) + '...' : scope.row.taskName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="80"  prop="createUser" label="办事人">
                    <template slot-scope="scope">
                        <span style="cursor:pointer">{{scope.row.createUser}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left"  width="180" prop="createTime" label="时间">
                    <template slot-scope="scope">
                        <span  style="cursor:pointer">{{scope.row.createTime.length > 20 ? scope.row.createTime.substring(0, 20) + '...' : scope.row.createTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="80"  prop="taskStatus" label="状态">
                    <template slot-scope="scope">
                        <span style="cursor:pointer">{{scope.row.taskStatus}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="mt20 flex-box">
                <div class="flex-1"></div>
                <el-pagination
                                background
                                small
                               @current-change="changePage"
                                @size-change="changeSize"
                                :page-sizes="pageSizes"
                               :current-page="tableObj.current"
                               :page-size="tableObj.size"
                               layout="total, sizes, prev, pager, next"
                               :total="tableObj.total"
                ></el-pagination>
            </div>
        </div>
        <IframeView ref="IframeView"></IframeView>
    </div>
</template>

<script>
    import {bpmnPageOwenProcess, bpmnPageTodoProcess, bpmnPageHasdoneProcess} from '@/api/bpmnApi/bpmn'
    import IframeView from "@/components/public/IframeView.vue";
    export default {
        name: "affair",
        props:['itemData', 'type'],
        components: {
            IframeView
        },
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                value: '',
                addDateShow: false,
                radio3: '待办',
                tableData: [],
                pageSizes:[10,20,30,50],
                tableObj:{
                    current:1,
                    size:10,
                    total:1
                },
                loading:false
            }
        },
        created(){
        },
        mounted(){
           this.getTableData()
        },
        methods: {
            getTableData(){
                this.loading = true;
                let rq = this.radio3 == '待办' ? bpmnPageTodoProcess : this.radio3 == '已办' ? bpmnPageHasdoneProcess : bpmnPageOwenProcess
                   let params = {
                       size: this.tableObj.size,
                       current: this.tableObj.current
                   }
                    rq(params).then(res =>{
                        if(res.data.code == '0'){
                            this.tableObj.total = res.data.data.total
                            this.tableData = res.data.data.records
                            this.loading = false;
                        }else {
                            this.loading = false;
                            this.$message.error(res.data.msg)
                        }
                   })
            },
            // 条数
            changeSize(value) {
                this.tableObj.size=value;
                this.tableObj.current=1;
                this.getTableData();
            },
            // 翻页
            changePage(value) {
                this.tableObj.current=value;
                this.getTableData();
            },
            goAff(){
                let routeData = this.$router.resolve({
                    name:'/mine/myAffair',
                    query: {}
                });
                window.open(routeData.href);
            },
            rowClick(row){
                this.$refs.IframeView.showView(row.taskUrl, row.taskInstId);
            }
        },
    }
</script>

<style scoped lang="less">
    .titleClass{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px #e9e9e9 solid;
        padding: 5px 0;
        >div {
            > i {
                font-size: 14px;
                padding: 0 3px;
            }
        }
    }
</style>
<style lang="less">
    .affair{
        .el-table td, .el-table th.is-leaf{
            border-bottom: none;
        }
    }
</style>